/* template */
<template><es-popup :show="(visible)"><div class="container" v-if="(visible)"><mpx-image @tap="close" src="https://ut-static.udache.com/webx/sfc/P9wPVGyKIwjrgsIB2p7Mz_clipboard_image_1698901019945.png" mode="widthFix" class="close-btn"></mpx-image><div class="title">补全身份信息</div><div class="subtitle">证件信息已过期，补全后方可购票</div><div class="user"><div class="name">{{supplyInfo.passenger_name}}</div><div class="idtype">{{supplyInfo.id_name}}</div></div><mpx-input type="idCard" placeholder="请输入身份证" :value="keywords" mpxModelEvent="input" @mpxModel='__model("keywords", $event, ["value"], undefined)' :maxlength="(18)" class="idno"/><mpx-view @tap="confirm" class="submit">提交</mpx-view></div></es-popup></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m45d92afa"}'>
.container
  width 280px
  height 280px
  background-color #ffffff
  border-radius 15px
  padding 32px 20px 0
  box-sizing border-box
  position relative
  line-height 1
  font-family PingFangSC-Regular
  font-weight 400
  .close-btn
    position absolute
    width 18px
    height 18px
    top 12px
    right 12px
  .title
    font-family PingFangSC-Medium
    font-size 20px
    font-weight 500
    text-align center
    color #333333
    margin-bottom 10px
  .subtitle
    font-size 12px
    text-align center
    color #999
    margin-bottom 32px
  .user
    @extend .flex-center
    height 16px
    .name
      font-family PingFangSC-Medium
      font-weight 500
      font-size 16px
      color #333333
    .idtype
      font-size 20px
      color #999
      padding 2px 4px
      border 1px solid #CCCCCC
      border-radius 4px
      transform scale(0.5)
      transform-origin 0 50%
      margin-left 6px
  .idno
    font-size 16px
    height 44px
    outline none
    background-color #F6F8FB
    margin-top 10px
    border-radius 8px
    padding-left 14px
    box-sizing border-box
    caret-color #FF6400
    &::placeholder
      color #ccc
  .submit
    @extend .flex-center
    justify-content center
    height 44px
    background-color #FF6400
    font-family PingFangSC-Medium
    font-weight 500
    font-size 16px
    border-radius 8px
    color #fff
    margin-top 32px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m45d92afa"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex45d92afa%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex45d92afa%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m45d92afa"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index45d92afa/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
